$(document).ready(function () {
  const buttons = $(".ygb-button");

  const figures = {
    dbl_mark: $("#dbl_mark"), //GigaMax
    dbsht_mark: $("#dbsht_mark"), //MegaMax
    max_mark: $("#max_mark"), //Max
    mid_mark: $("#mid_mark"), //Midi
    sht_mark: $("#sht_mark"), //Short
    min_mark: $("#min_mark"), //Mini
    pod_mark: $("#pod_mark"), //Pod
    drp_mark: $("#drp_mark"), //Drop
    lgr_mark: $("#lgr_mark"), //Lounger
    bbl_mark: $("#bbl_mark"), //Bubble
    prm_mark: $("#prm_mark"), //Pyramid
    hgr_mark: $("#hgr_mark"), //Hugger
    hgb_mark: $("#hgb_mark"), //Hugibo
    sprt_mark: $("#sprt_mark"), //Support
    rolmx_mark: $("#rolmx_mark"), //Roll Max
    crlg_mark: $("#crlg_mark"), //Caterpillar Roll Long
    otmn_mark: $("#otmn_mark"), //Ottoman
  };

  buttons.on("click", function () {
    buttons.removeClass("ygb-class-active");
    $(this).addClass("ygb-class-active");
  });

  // $("#ygb-btn-1to6").on("click", function () {
  //   Object.values(figures).forEach((figure) => figure.show());
  // });
  showFigures(["dbl_mark","dbsht_mark","max_mark","rolmx_mark","crlg_mark","mid_mark", "sht_mark","pod_mark", "drp_mark", "bbl_mark", "min_mark", "prm_mark", "lgr_mark", "hgb_mark","otmn_mark"]);
  
  $("#ygb-btn-1to6").on("click", function () {
    showFigures(["dbl_mark","dbsht_mark","max_mark","rolmx_mark","crlg_mark","mid_mark", "sht_mark","pod_mark", "drp_mark", "bbl_mark", "min_mark", "prm_mark", "lgr_mark", "hgb_mark","otmn_mark"]);
  });

  $("#ygb-btn-1to3").on("click", function () {
    showFigures(["dbsht_mark","max_mark","rolmx_mark","crlg_mark","mid_mark", "sht_mark","pod_mark", "drp_mark", "bbl_mark", "min_mark", "prm_mark", "lgr_mark", "hgb_mark","otmn_mark"]);
  });

  $("#ygb-btn-1to2").on("click", function () {
    showFigures(["mid_mark", "sht_mark","pod_mark", "drp_mark", "bbl_mark", "min_mark", "prm_mark", "lgr_mark", "hgb_mark","otmn_mark"]);
  });

  $("#ygb-btn-1").on("click", function () {
    showFigures(["pod_mark", "drp_mark", "bbl_mark", "min_mark", "prm_mark", "lgr_mark", "hgb_mark","otmn_mark"]);
  });

  function showFigures(ids) {
    Object.keys(figures).forEach((id) => {
      if (ids.includes(id)) {
        figures[id].show();
      } else {
        figures[id].hide();
      }
    });
  }

  // buttons.first().click();
  buttons.first().addClass("ygb-class-active");
  // $("#ygb-btn-1to6").addClass("ygb-class-active");


  const ygbScrollButton = $("#ygb-scroll-button");
  const sofaPartsContents = $("#sofa_parts");
  ygbScrollButton.on("click", function () {
    sofaPartsContents.animate(
      { scrollLeft: sofaPartsContents.scrollLeft() + 100 },
      300
    );
  });
});
